module.exports = __webpack_public_path__ + "static/media/toilet-paper.37eb5cf6.svg";